export interface Testimonial {
  id: number;
  initials: string;
  name: string;
  date: string;
  rating: number;
  text: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    initials: "LP",
    name: "Latasha Pickett",
    date: "June 2025",
    rating: 5,
    text: "This company was very professional and completed a very tough job in record time. I hired them one day prior and they showed up on time, and went above and beyond to finish on time. Highly recommend and I will be using them again.",
  },
  {
    id: 2,
    initials: "LT",
    name: "Liceth Teran",
    date: "November 2024",
    rating: 5,
    text: "We hired Prime for cleaning across our restaurant locations in a busy mall, and we couldn't be happier with their work. Their team is punctual, thorough, and keeps each space spotless. Highly recommended for any business looking for reliable and professional cleaning!",
  },
  {
    id: 3,
    initials: "SP",
    name: "Santiago Parra Torres",
    date: "November 2024",
    rating: 5,
    text: "We recently brought Prime to support our kitchen operations at the hotel, and I couldn't be happier with the outcome. The staff they provided was professional, efficient, and integrated seamlessly with our team. Prime really understands what a high-standard facility requires.",
  },
  {
    id: 4,
    initials: "NN",
    name: "Nancy Navarro",
    date: "December 2025",
    rating: 5,
    text: "I met with the Prime team and they were great! Very informative and very polite. I love the way they explained their process and services to me. They clearly take pride in what they do and it shows.",
  },
];
